<template>
    <div>
        <div class="content-nav-wrapper">
            <div class="title-wrapper">
                <span class="title">{{ $t('comb.copyrightWorkManagement') }}</span>
                <span>{{ $t('word.total') }} {{totalCount}} {{ $t('word.item') }}</span>
            </div>
            <div class="tabs-wrapper">
                <button :class="{'active': statusCode===0}" @click="getWorkList(0, 1)"><span>{{ $t('word.all') }}</span></button>
                <button :class="{'active': statusCode===1}" @click="getWorkList(1, 1)"><span>{{ $t('word.toBeAudit') }}</span></button>
                <button :class="{'active': statusCode===2}" @click="getWorkList(2, 1)"><span>{{ $t('comb.passAudit') }}</span></button>
                <button :class="{'active': statusCode===5}" @click="getWorkList(5, 1)"><span>{{ $t('comb.notPassAudit') }}</span></button>
            </div>
        </div>
        <div class="copyright-empty-work-list" v-if="totalCount === 0 && statusCode===0" >
            <p class="no-work">您还没有上传作品，现在就去<router-link :to="{name: 'uploadCopyright'}">添加</router-link>作品制作有声读物吧 </p>
            <img :src="`${IMG_HOST}copyright_blank_logo@2x.png`">
        </div>
        <div class="copyright-works-list-wrapper" v-loading.body="pageLoading" v-else>
            <div v-for="item in workList" class="work-item">
                <div class="title">
                    <div><span>{{item.statusLabel}}</span></div>
                </div>
                <div class="work-content-wrapper">
                    <img class="prop-img" v-if="item.bookContract && item.bookContract.exclusive" :src="$store.state.IMG_HOST+'exclusive-icon@2x.png'">
                    <img v-if="item.coverImg" class="work-cover" :src="$store.state.UPLOAD_IMG_HOST+item.coverImg">
                    <img v-else class="work-cover" :src="$store.state.IMG_HOST+'bookCoverDefault.png'">
                    <div :class="{'work-content-single': item.requirementId}" class="work-content">
                        <div class="content">
                            <span class="work-name">{{ item.title }}</span>
                            <div v-if="item.author"><span class="work-anchor">{{ item.author }}</span></div>
                            <span class="category-label">{{ item.categoryLabel }}</span>
                        </div>
                        <div class="buttons">
                            <a v-if="item.status===5" @click="showAdvice(item.id)" class="check-task" size="small">查看建议</a>
                            <a type="button" v-if="item.status === 9 && item.bookContract.ownerCoverCost" class="check-task" 
                            @click="dialogVisible=true"
                            >{{ $t('comb.releaseTask') }}</a>
                            <router-link type="button" :to="{name: 'bookDetail', params:{id: item.id} }" class="check-task">{{ $t('comb.checkWorkDetail') }}</router-link>
                            <router-link v-if="item.requirementId" type="button" :to="{name: 'workProgress', params:{ id: item.materialId }}" class="check-task">{{ $t('comb.checkRequirement') }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="center-works-pagination" v-if="totalPage>=2">
            <el-pagination @current-change="changePage" :current-page="pageIndex" :page-count="totalPage" layout="prev, pager, next"></el-pagination>
        </div>
        <el-dialog title="页面跳转" custom-class="detailDialog" v-model="dialogVisible" size="mini">
            <span>为了更好地为您服务，将前往喜配音平台进行后续操作！</span>
            <div class="buttons">
              <el-button type="primary" plain @click="dialogVisible=false">{{ $t('word.cancel') }}</el-button>
              <a type="button" class="agree-btn" @click="dialogVisible=false" target="_blank" :href="$store.state.DUB_HOST">跳转至喜配音</a>
            </div>
        </el-dialog>
    </div>
</template>
<script>
  /**
   * statusCode: 0 全部； 1 待审核； 2 审核通过； 3 审核不通过
   * totalCount: 作品数量
   */
  import axios from 'axios';
    export default {
        data() {
            return {
              dialogVisible: false,
              pageLoading: true,
              totalCount: 0,
              workList: [],
              totalPage: 0,
              pageIndex: 1,
              pageNum: 10,
              statusCode: 3
            }
        },
        beforeMount() {
            this.getWorkList(0, 1);
        },
        methods: {
            changePage(pageIndex) {
              this.getWorkList(this.statusCode, pageIndex);
            },
            showAdvice(bookId) {
              const that = this;
              axios.get(`/api/book/detail/${bookId}`).then(res => {
                const book = res.data.data;
                that.$confirm(book.bookApply.auditRemark, '修改建议', {
                  confirmButtonText: '前往修改',
                  cancelButtonText: '关闭',
                  type: 'warning',
                  callback: (action) => {
                    if(action === 'confirm') {
                      this.$router.push(
                        {
                          name: 'uploadCopyright',
                          params: {
                            bookId: bookId
                          }
                        });
                    }
                  }
                });
              }).catch(error => {
                this.$message({
                  type: 'error',
                  message: error.message
                });
              });
            },
            getWorkList(statusCode, pageIndex) {
              this.statusCode = statusCode;
              this.pageLoading = true;
              const that = this;
              this.pageIndex = pageIndex;
              that.workList = null
              axios.get(`/api/book/list/status/${statusCode}/pagenum/${pageIndex}`,{
              }).then(res => {
                if (res.data.code === 200) {
                  that.workList = res.data.data.items;
                  that.totalPage = res.data.data.pages;
                  that.totalCount = res.data.data.total;
                }
                that.pageLoading = false;
              });
            },
        },
        computed: {
            IMG_HOST() {
                return this.$store.state.IMG_HOST;
            }
        }
    }
</script>
<style lang="sass" scoped>
    @import "../../../sass/copyright/copyrightManagement/copyright-management-list.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// WorksManagement.vue?a1afc49e